export { default as PasteOptionPlugin } from './plugin/PasteOptionPlugin';
